import React from 'react';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';
import { services, businessInfo } from '../data/mock';
import QuoteCalculator from '../components/QuoteCalculator';
import './Pages.css';

const Services = () => {
  return (
    <div className="page-services">
      {/* Hero Section */}
      <section className="services-hero section-padding-small section-dark">
        <div className="container">
          <h1 className="hero-medium text-white">Installation Services & Pricing</h1>
          <p className="body-large space-top-md text-light">
            Transparent pricing for professional appliance installation across Greater Vancouver and Fraser Valley
          </p>
        </div>
      </section>

      {/* Quote Calculator */}
      <section className="section-padding section-light">
        <div className="container">
          <QuoteCalculator />
        </div>
      </section>

      {/* Pricing Tiers */}
      <section className="section-padding section-light">
        <div className="container">
          <div className="section-header">
            <h2 className="heading-1">Service Tiers</h2>
            <p className="body-regular text-secondary">
              Professional installation for every premium brand
            </p>
          </div>
          <div className="pricing-grid">
            {services.map((service) => (
              <div key={service.id} className="pricing-card">
                <div className="pricing-header">
                  <h2 className="heading-2 text-white">{service.category}</h2>
                  <p className="body-regular text-light space-top-sm">
                    {service.description}
                  </p>
                </div>
                
                <div className="pricing-amount space-top-lg">
                  <span className="price-range">{service.priceRange}</span>
                </div>

                <div className="pricing-brands space-top-md">
                  {service.brands.map((brand) => (
                    <span key={brand} className="brand-badge">{brand}</span>
                  ))}
                </div>

                <ul className="pricing-features space-top-lg">
                  {service.features.map((feature) => (
                    <li key={feature} className="pricing-feature-item">
                      <Check size={16} className="feature-check" />
                      <span className="body-regular text-light">{feature}</span>
                    </li>
                  ))}
                </ul>

                <div className="space-top-lg">
                  <Link to="/contact" className="btn-primary" style={{ width: '100%' }}>
                    Get a Quote
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What's Included */}
      <section className="section-padding">
        <div className="container">
          <div className="grid-two-column">
            <div>
              <h2 className="heading-1">What's Included</h2>
              <p className="body-regular text-secondary space-top-md">
                Every installation is completed with precision and care, ensuring your premium appliances function perfectly.
              </p>
            </div>
            <div>
              <ul className="included-list">
                <li className="included-item">
                  <Check size={20} className="feature-check" />
                  <div>
                    <h4 className="body-large">Professional Assessment</h4>
                    <p className="body-small text-secondary">Pre-installation review and measurements</p>
                  </div>
                </li>
                <li className="included-item">
                  <Check size={20} className="feature-check" />
                  <div>
                    <h4 className="body-large">Complete Installation</h4>
                    <p className="body-small text-secondary">Electrical, plumbing, and panel integration</p>
                  </div>
                </li>
                <li className="included-item">
                  <Check size={20} className="feature-check" />
                  <div>
                    <h4 className="body-large">Testing & Calibration</h4>
                    <p className="body-small text-secondary">Full function testing before completion</p>
                  </div>
                </li>
                <li className="included-item">
                  <Check size={20} className="feature-check" />
                  <div>
                    <h4 className="body-large">Clean Workspace</h4>
                    <p className="body-small text-secondary">Complete cleanup after installation</p>
                  </div>
                </li>
                <li className="included-item">
                  <Check size={20} className="feature-check" />
                  <div>
                    <h4 className="body-large">Warranty Compliance</h4>
                    <p className="body-small text-secondary">Installation meets manufacturer requirements</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Service Area */}
      <section className="section-padding-small service-area-section">
        <div className="container">
          <div className="service-area-content">
            <h2 className="heading-1">Service Area</h2>
            <p className="body-large space-top-md">
              Proudly serving <strong>{businessInfo.serviceArea}</strong>
            </p>
            <p className="body-regular text-secondary space-top-md">
              Professional appliance installation across Metro Vancouver, Surrey, Langley, Abbotsford, and surrounding areas.
            </p>
            <div className="space-top-lg">
              <Link to="/contact" className="btn-secondary">
                Check if Joe serves your area
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="hero-medium">Ready to Get Started?</h2>
            <p className="body-large space-top-md">
              Request a detailed quote for your appliance installation
            </p>
            <div className="space-top-lg">
              <Link to="/contact" className="btn-primary">
                Request Your Quote
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
